import { useEffect, useState, useContext } from 'react';
import TextField from '@mui/material/TextField';
import Storage from '../../../session/storage';
import Autocomplete from '@mui/material/Autocomplete';
import CONSTANT from '../../../Constant/Constant';
import { sortTranslated } from '../../shared/util';
import { DropdownContext } from '../../../context/DropDownContext';
import { UiPicklistContext } from '../../../context/UiPicklistContext';

const InputDetail = (props) => {
    const is_veeva = props.vendor == "Veeva Network"
    const [value, setValue] = useState({ [props.label]: props.value || null })
    const [lengthFlag, setFlag] = useState();
    const label = props.label;
    const { dropdownvalue } = useContext(DropdownContext);
    const { uiDropdownValue } = useContext(UiPicklistContext);

    /**
     * map name to key
     * @param {*} name name of attribute
     * @returns key name of attribute
     */
    const getOptionKey = (name, is_veeva = false) => {
        switch (name) {
            case 'Classification Code':
                return 'Classification';
            case 'Sub Classification Code':
                return 'SubClassification';
            case 'Prefix':
                return 'Title';
            case 'Other Specialty':
                return 'Specialty';
            case 'Primary Specialty':
                if (is_veeva) {
                  return 'Specialty'
                }
                return 'Specialty'
            case 'State/Province':
                return 'StateProvince';
            case 'Specialty Type':
                return 'SpecialtyType';
                case 'Identifiers Type':
                    return 'AltIDType';
                case 'Identifiers Sub Type':
                    return 'AltIDSubtype';        
                        
            case 'Country':
                return 'Country';     
            case 'Country Code':
                return 'Country'
            default:
                return name;

                
        }
    }

    /**
     * Map name to ID
     * @param {*} name 
     * @returns ID of atrribute
     */
    const getId = (name) => {
        switch (name) {
            case 'Classification Code':
                return 'ClassificationCode';
            case 'Sub Classification Code':
                return 'SubClassificationCode';
            case 'Suffix Name':
                return 'SuffixName';
            case 'Middle Name':
                return 'MiddleName';
          case 'Primary Specialty':
            return 'PrimarySpecialty';
          case 'State/Province':
            return 'StateProvince';
            case 'Primary Specialty':
                return 'PrimarySpecialty';
            case 'Other Specialty':

                return 'OtherSpecialty';
     
            case 'Identifiers Type':
                return 'Type';
            case 'Identifiers Sub Type':
                return 'SubType'; 

            default:
                return name;
        }
    }

    
    let options = CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim())) ? Storage.getLovBoundedList() : Storage.getPickList();
    options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? {[props.entity]:{ [label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()]} } : options;
       
    const [required, setRequired] = useState();
    let option = options[props.entity][getOptionKey(label.trim(), is_veeva)];
    let propOptions = props.options
    if (propOptions) {
      option = propOptions
    }


    useEffect(() => {
        if(dropdownvalue === undefined || dropdownvalue === null || dropdownvalue.length === 0) return;
        options = CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim())) ? dropdownvalue : uiDropdownValue;
        options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? {[props.entity]:{ [label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()]} } : options;
        option = options?.[props.entity]?.[getOptionKey(label.trim(), is_veeva)] ? options[props.entity][getOptionKey(label.trim(), is_veeva)] : null;
        propOptions = props.options
        if (propOptions) {
        option = propOptions
        }
    },[dropdownvalue])

    /**
     * Pass value to parent
     * @param {*} event 
     */
    const passToParent = async (event) => {
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0));
        await setValue({[props.label] :event.target.value})
        props.updatedValue({ value: event.target.value === null ? '' : event.target.value }, required && (event.target.value === null || (event.target.value !== null && event.target.value.length === 0)))
    }

    /**
     * Handel Input Change
     * @param {*} event : event
     * @param {*} passTo : parent flag
     * @param {*} reqFlag : validation flag
     */
    const handelInput = (event, passTo, reqFlag) => {
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))
        setValue({[props.label] : event.target.value})

        if (passTo) {
            passToParent(event)
        }
    }


    useEffect(() => {
        let flag = (value === null) || (value !== null && value !== undefined && value.length === 0);
        flag = (props.error && flag)
        setFlag(flag);
        setRequired(props.newHCP !== undefined ? CONSTANT.REQUIRED_HCP.includes(label.trim()) : !CONSTANT.OPTIONAL.includes(getId(label.trim())))
        if (props.clear && option === undefined) {
            setValue({[props.label] : '' })
        } else if (props.clear && option !== undefined) {
            setValue({[props.label] : '' })
        }
    }, [props.clear, option, props.error, label, props.newHCP])

    return (
        <>
            { 
            
                props.date === false && option !== undefined &&
                <Autocomplete
                    value={(label.trim() === 'Other Specialty' && value[props.label] === null) ? [] :
                        value[props.label]?.split(' | ')?.length > 1 ?
                            option?.flatMap(group => group.options ? group.options : group).find(d => d.split(' | ').length > 0 && d.split(' | ')[d.split(' | ').length - 1].split('//')[0] === value[props.label]?.split(' | ')[value[props.label]?.split(' | ').length - 1])
                            : value[props.label]}
                    key={label}
                    onChange={(event, value) => 
                        handelInput({
                          target: { 
                            value: label.trim() === 'Other Specialty' 
                              ? value.length > 0 
                                ? value.map(res => res.split('//')[0]) 
                                : value 
                              : value?.split('//')[0].length > 0 
                                ? value.split('//')[0] 
                                : value 
                          }
                        }, true)}
                    options={option.flatMap(group => group.options ? sortTranslated(group.options) : sortTranslated(group))}
                    getOptionLabel={(option) => option?.split('//')[0]}
                    groupBy={(option) => {return option?.includes('//UnClassified') ? 'Unclassified' :`HCP - ${label} ` }}
                    isOptionEqualToValue={(option, value) => option === value}
                    id={label}
                    name={label}
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} 
                            variant="standard"
                            helperText=""
                             />}
                />
            }
            {
                props.date === true && props.type !== 'number' && option === undefined &&
                <TextField
                    value={value[props.label] || ''}
                    id={props.label}
                    variant="standard"
                    name={props.label}
                    onChange={handelInput}
                    helperText=""
                    // helperText={((lengthFlag) && required) ? "Please Enter Something" : " "}
                    onBlur={passToParent}
                    className={`w-100`}
                    type="date"
                    inputProps={{ max: "9999-12-31" }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            }
            {
                props.date === false && option === undefined &&
                < TextField
                    type={props.type}
                    key={props.label}
                    variant="standard"
                    helperText=""
                    // helperText={((lengthFlag) && required) ? "Please Enter Something" : " "}
                    value={value[props.label] ||  ''}
                    onChange={handelInput}
                    onBlur={passToParent}
                    id={props.label}
                    name={props.label}
                    color="primary" className={`w-100 input-text`} />
            }
        </>
    )

}

export default InputDetail;